import React, { useEffect } from 'react';
import Post from '../../components/Post';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ROOT, SAVED_POSTS } from '../../constants/routes';
import {
  selectFeed,
  selectFeedLastPage,
  selectFeedPage,
  selectIsFetchingFeed,
} from '../../reducers/feed/feed.selectors';
import { fetchFeed } from '../../reducers/feed/feed.actions';
import Loader from '../../components/Loader';
import { clearFeedActionCreator } from '../../reducers/feed/feed.actionCreators';
import { useLocation } from 'react-router-dom';
import { LoadMoreButton } from 'components/generic-components/LoadMoreButton';

const SavedPost = ({ userId, ...rest }) => {
  const feed = useSelector(selectFeed);
  const location = useLocation();
  const page = useSelector(selectFeedPage);
  const lastPage = useSelector(selectFeedLastPage);
  const isFetchingFeed = useSelector(selectIsFetchingFeed);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getParams = () => {
    let params = {};
    if (location.pathname === SAVED_POSTS) {
      params.type = 'bookmarks';
    }
    return params;
  };
  useEffect(() => {
    if (!isFetchingFeed) {
      dispatch(fetchFeed(userId ? userId : null, getParams()));
    }
    return () => {
      dispatch(clearFeedActionCreator());
    };
  }, [location]);
  const loadMorePosts = () => {
    let params = getParams();
    params.page = page + 1;
    dispatch(fetchFeed(userId ? userId : null, params));
  };
  return (
    <div className={'col-12 col-md-9  p-3'}>
      <Loader isLoadin={isFetchingFeed && !feed.length} height={311} size={60}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
          {feed.length
            ? feed.map(el => (
              <div
                key={'post' + el.id}
                style={{
                  width: 159,
                  height: 102,
                  display: 'flex',
                  flexDirection: 'row',
                  marginRight: 10,
                  marginBottom: 10,
                }}
              >
                <Post post={el} showHeader={false} showFooter={false} />
              </div>
            ))
            : location.pathname === ROOT && <div className="text-center">{t('not subscribed to anyone.')}</div>}
          {(page < lastPage || (page === lastPage && isFetchingFeed)) && (
            <Loader isLoadin={isFetchingFeed} height={36} size={28}>
              <LoadMoreButton handleLoadMore={loadMorePosts} />
            </Loader>
          )}
        </div>
      </Loader>
    </div>
  );
};

export default SavedPost;
